"use client";

import { SubscribeToCommunicationCenter } from "@/components/common/subscribe-to-communication-center/subscribe-to-communication-center";
import { trans } from "@/service/i18n/i18n";
import { Button } from "@/components/ui/button";
import { SuperLink as Link } from "@/components/common/super-link";

export const WebinarActionWithSubscriptionList = ({
  state,
  close,
  isOpen,
}: {
  state: SubscriptionListState;
  close: () => void;
  isOpen: boolean;
}) => {
  const url = state.options?.url;
  const onSuccess = () => {
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <SubscribeToCommunicationCenter
      state={state}
      onSuccess={onSuccess}
      Action={
        <>
          {url
            ? "Przejdź do nagrania"
            : trans("subscription_list.form.confirm")}
        </>
      }
      ActionSubscribed={
        <>
          {url && (
            <>
              <Button variant={"blue"} asChild={true}>
                <Link href={url}>Przejdź do nagrania</Link>
              </Button>
              <br />
            </>
          )}
        </>
      }
      close={close}
      isOpen={isOpen}
    />
  );
};
